"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffSupportRoomTimelineTrack = exports.SupportQueueAdmissionOutcome = exports.SupportSessionStatus = exports.SupportSessionOutcome = exports.SupportTicketResolution = exports.SupportRoomRecoveryDecision = exports.SupportRoomErrorCode = exports.SUPPORT_QUEUE_ADMISSION_REQUEST_TIMEOUT_MSEC = void 0;
exports.SUPPORT_QUEUE_ADMISSION_REQUEST_TIMEOUT_MSEC = 30_000;
var SupportRoomErrorCode;
(function (SupportRoomErrorCode) {
    SupportRoomErrorCode["ROOM_UNAVAILABLE"] = "ROOM_UNAVAILABLE";
    SupportRoomErrorCode["SUPPORT_ROOM_REQUEST_FAILED"] = "SUPPORT_ROOM_REQUEST_FAILED";
})(SupportRoomErrorCode || (exports.SupportRoomErrorCode = SupportRoomErrorCode = {}));
var SupportRoomRecoveryDecision;
(function (SupportRoomRecoveryDecision) {
    SupportRoomRecoveryDecision["end"] = "end";
    SupportRoomRecoveryDecision["displaced"] = "displaced";
    SupportRoomRecoveryDecision["rejoin"] = "rejoin";
})(SupportRoomRecoveryDecision || (exports.SupportRoomRecoveryDecision = SupportRoomRecoveryDecision = {}));
var SupportTicketResolution;
(function (SupportTicketResolution) {
    SupportTicketResolution["RESOLVED"] = "resolved";
    SupportTicketResolution["UNRESOLVED"] = "unresolved";
})(SupportTicketResolution || (exports.SupportTicketResolution = SupportTicketResolution = {}));
/**
 * What a room's latest support session still owes the staff. A customer who ends the call themselves ends the
 * session while the ticket decision is outstanding, so `pending` is the state the staff room has to prompt for.
 */
var SupportSessionOutcome;
(function (SupportSessionOutcome) {
    SupportSessionOutcome["pending"] = "pending";
    SupportSessionOutcome["resolved"] = "resolved";
    SupportSessionOutcome["unresolved"] = "unresolved";
})(SupportSessionOutcome || (exports.SupportSessionOutcome = SupportSessionOutcome = {}));
var SupportSessionStatus;
(function (SupportSessionStatus) {
    SupportSessionStatus["queued"] = "queued";
    SupportSessionStatus["inProgress"] = "inprogress";
    SupportSessionStatus["ended"] = "ended";
})(SupportSessionStatus || (exports.SupportSessionStatus = SupportSessionStatus = {}));
var SupportQueueAdmissionOutcome;
(function (SupportQueueAdmissionOutcome) {
    SupportQueueAdmissionOutcome["admitted"] = "admitted";
    SupportQueueAdmissionOutcome["empty"] = "empty";
    SupportQueueAdmissionOutcome["exhausted"] = "exhausted";
    SupportQueueAdmissionOutcome["taken"] = "taken";
})(SupportQueueAdmissionOutcome || (exports.SupportQueueAdmissionOutcome = SupportQueueAdmissionOutcome = {}));
/** Which bar lane an interval belongs to on the staff support timeline. */
var StaffSupportRoomTimelineTrack;
(function (StaffSupportRoomTimelineTrack) {
    StaffSupportRoomTimelineTrack["room"] = "room";
    StaffSupportRoomTimelineTrack["session"] = "session";
})(StaffSupportRoomTimelineTrack || (exports.StaffSupportRoomTimelineTrack = StaffSupportRoomTimelineTrack = {}));
